import React, { useEffect } from "react";
import { Loader } from "../components/Loader";
import { COPY } from "../constants/copy";

interface LoaderScreenProps {
  onComplete: () => void;
}

export const LoaderScreen: React.FC<LoaderScreenProps> = ({ onComplete }) => {
  useEffect(() => {
    const timer = setTimeout(onComplete, 2000);
    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-warmWhite dark:bg-darkBg transition-colors duration-400">
      <Loader message={COPY.loader.message} />
    </div>
  );
};
